import { Linking } from 'react-native';

export interface ComposeEmailOptions {
  to?: string[];
  bcc?: string[];
  subject?: string;
  body?: string;
}

/**
 * Opens the user's default mail client with a pre-filled mailto URL.
 */
export const composeEmail = ({
  to = [],
  bcc = [],
  subject = '',
  body = '',
}: ComposeEmailOptions): Promise<void> => {
  const recipients = to.join(',');
  const bccRecipients = bcc.join(',');

  const params: string[] = [];
  if (bccRecipients) params.push(`bcc=${encodeURIComponent(bccRecipients)}`);
  if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
  if (body) params.push(`body=${encodeURIComponent(body)}`);

  const queryString = params.length > 0 ? `?${params.join('&')}` : '';
  const mailtoUrl = `mailto:${recipients}${queryString}`;

  return Linking.openURL(mailtoUrl);
};

export default composeEmail;
